import { FC } from "react";
import { isArray, isUndefined } from "ramda-adjunct";
import { colInitialsImage } from "@components-common/tables";

const GroupColumnComponent: FC<any> = ({ cell }) => (
  <>{cell !== undefined ? cell : "All students"}</>
);
export const GroupColumn = {
  id: "custom",
  text: "Group",
  dataField: "group.name",
  formatter: (cell: any) => <GroupColumnComponent cell={cell} />,
  sort: false,
  order: 215,
};

export const StudentsCountColumn = {
  id: "custom",
  text: "Students",
  formatter: (cell: any, { groupUserProfile }: any) => {
    const count = groupUserProfile.filter(
      (groupUser: any) => groupUser.user.role.toLowerCase() === "student"
    ).length;
    return count;
  },
  sort: false,
  order: 211,
};

export const LecturersColumn = {
  id: "lecturer",
  text: "Lecturers",
  classes: "ebd-initials-first",
  formatter: (col: any, row: any, index: any, extraData: any) => {
    if (isUndefined(row?.groupUserProfile) || !isArray(row?.groupUserProfile)) {
      //TODO: log when there are not lecturers - error
      return <></>;
    }
    const lecturers = row.groupUserProfile
      .filter(
        (groupUser: any) => groupUser.user.role.toLowerCase() === "lecturer"
      )
      .map((groupUser: any) => groupUser.user);

    return (
      <>
        <div className="ebd-initials-column">
          {lecturers.map((x: any) => {
            return (
              <div key={x.id} className={"ebd-initials"}>
                {colInitialsImage(x)}
              </div>
            );
          })}
        </div>
      </>
    );
  },
  sort: false,
};
